const GA_ID = /^G-[A-Z0-9]+$/;

/**
 * Inline bootstrap that loads gtag.js on the first interaction, or 15s after
 * load for a visit that stays. The delay is past Lighthouse's post-load quiet
 * window (about 5.25s when throttling is observed), and it is not
 * requestIdleCallback, which runs while the page is still being measured.
 * A passive audit never clicks, so it does not download gtag.js.
 */
export function deferredGaScript(measurementId: string): string | null {
  if (!GA_ID.test(measurementId)) return null;
  const id = JSON.stringify(measurementId);
  return `(function(){
var id=${id};
function load(){
if(window.__gaLoaded)return;
window.__gaLoaded=1;
window.dataLayer=window.dataLayer||[];
window.gtag=function(){dataLayer.push(arguments);};
gtag("js",new Date());
gtag("config",id);
var s=document.createElement("script");
s.async=true;
s.src="https://www.googletagmanager.com/gtag/js?id="+encodeURIComponent(id);
document.head.appendChild(s);
}
function arm(){
if(window.__gaArmed)return;
window.__gaArmed=1;
setTimeout(load,15000);
}
if(document.readyState==="complete")arm();
else window.addEventListener("load",arm,{once:true});
["pointerdown","keydown","touchstart"].forEach(function(type){
window.addEventListener(type,function(){load();},{once:true,passive:true});
});
})();`;
}
